/* esm.sh - date-fns@4.1.0/_lib/getRoundingMethod */
function o(n){return r=>{let t=(n?Math[n]:Math.trunc)(r);return t===0?0:t}}export{o as getRoundingMethod};
//# sourceMappingURL=getRoundingMethod.mjs.map